import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import MFASetup from './pages/MFASetup';
import MFAVerify from './pages/MFAVerify';
import Dashboard from './pages/Dashboard';
import Credentials from './pages/Credentials';
import CredentialDetail from './pages/CredentialDetail';
import AuditLogs from './pages/AuditLogs';
import Users from './pages/Users';
import MFAManagement from './pages/MFAManagement';
import Shares from './pages/Shares';
import ShareView from './pages/ShareView';
import PasswordGenerator from './pages/PasswordGenerator';
import Kubeconfig from './pages/Kubeconfig';
import KubeconfigDetail from './pages/KubeconfigDetail';
import Vpn from './pages/Vpn';
import VpnDetail from './pages/VpnDetail';
import Backup from './pages/Backup';
import Profile from './pages/Profile';
import Layout from './components/Layout';
import './App.css';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--bg-app)' }}>
        <div className="spinner spinner-lg" />
      </div>
    );
  }

  return user ? <>{children}</> : <Navigate to="/login" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/mfa/setup" element={<MFASetup />} />
      <Route path="/mfa/verify" element={<MFAVerify />} />
      <Route path="/share/:token" element={<ShareView />} />
      <Route path="/share/kubeconfig/:token" element={<ShareView />} />
      <Route path="/share/vpn/:token" element={<ShareView />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="credentials" element={<Credentials />} />
        <Route path="credentials/:id" element={<CredentialDetail />} />
        <Route path="generate-password" element={<PasswordGenerator />} />
        <Route path="kubeconfig" element={<Kubeconfig />} />
        <Route path="kubeconfig/:id" element={<KubeconfigDetail />} />
        <Route path="vpn" element={<Vpn />} />
        <Route path="vpn/:id" element={<VpnDetail />} />
        <Route path="backup" element={<Backup />} />
        <Route path="shares" element={<Shares />} />
        <Route path="audit" element={<AuditLogs />} />
        <Route path="users" element={<Users />} />
        <Route path="mfa-management" element={<MFAManagement />} />
        <Route path="profile" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;

